export const DDialogMode = wcardinal.ui.DDialogMode;